import type { PropsWithChildren } from 'react'
import React from 'react'
import { type FormikValues, useFormikContext } from 'formik'

import { TtOption } from '@23/react'

import type {
  FieldNameMatchingAcceptedType,
  FormikFormControlProps,
} from './index'

const TtOptionFormik = <FV extends FormikValues>({
  name,
  value,
  children,
  ...props
}: PropsWithChildren<FormikFormControlProps<'tt-option'>> & {
  name:
    | FieldNameMatchingAcceptedType<
        FV,
        HTMLTtOptionElement['value'] | undefined
      >
    | FieldNameMatchingAcceptedType<
        FV,
        HTMLTtOptionElement['value'][] | undefined
      >
}) => {
  const { values } = useFormikContext<FV>()

  const isSelected = Array.isArray(values[name])
    ? values[name].includes(value)
    : values[name] === value

  return (
    <TtOption value={value} selected={isSelected ? true : undefined} {...props}>
      {children}
    </TtOption>
  )
}

export { TtOptionFormik }
